import React from 'react';
import { motion } from 'framer-motion';

const ScoreCircle = ({ score, label, delay }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.5 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    transition={{ delay, duration: 0.5 }}
    className="flex flex-col items-center gap-4"
  >
    <div className="relative w-32 h-32 flex items-center justify-center">
      {/* Background Circle */}
      <svg className="w-full h-full transform -rotate-90">
        <circle
          cx="64"
          cy="64"
          r="60"
          stroke="rgba(255,255,255,0.1)"
          strokeWidth="8"
          fill="transparent"
        />
        {/* Progress Circle */}
        <motion.circle
          cx="64"
          cy="64"
          r="60"
          stroke="#00FF94"
          strokeWidth="8"
          fill="transparent"
          strokeDasharray={2 * Math.PI * 60}
          strokeDashoffset={2 * Math.PI * 60} // Start empty
          whileInView={{ strokeDashoffset: 0 }} // Animate to full
          viewport={{ once: true }}
          transition={{ delay: delay + 0.5, duration: 1.5, ease: "easeOut" }}
          strokeLinecap="round"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-4xl font-bold text-[#00FF94] font-['Space_Grotesk']">{score}</span>
      </div>
    </div>
    <span className="text-gray-300 font-medium uppercase tracking-wider text-sm">{label}</span>
  </motion.div>
);

const Performance = () => {
  return (
    <section className="py-20 bg-[#020010] relative border-y border-[var(--border-glass)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-block mb-4 px-4 py-1 rounded-full border border-[#00FF94]/30 bg-[#00FF94]/10">
              <span className="text-[#00FF94] font-bold text-xs uppercase tracking-wider">Performance Garantie</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 font-['Space_Grotesk'] text-white">
              Plus Rapide Que <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00FF94] to-[#00C6FF]">99% du Web</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed">
              Google pénalise les sites lents. Vos clients aussi.
              Nos sites chargent instantanément, assurant une expérience fluide et un meilleur référencement.
              Ne perdez plus jamais un client à cause d'un chargement lent.
            </p>
            <ul className="space-y-4">
              {[
                "Chargement en moins de 0.5s",
                "Optimisé pour Google (Core Web Vitals)",
                "Code propre et léger",
                "Hébergement haute performance"
              ].map((item, i) => (
                <motion.li 
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 + (i * 0.1) }}
                  className="flex items-center gap-3 text-gray-300"
                >
                  <span className="w-6 h-6 rounded-full bg-[#00FF94]/20 flex items-center justify-center text-[#00FF94] text-xs">✓</span>
                  {item}
                </motion.li>
              ))}
            </ul>
          </motion.div>

          <div className="grid grid-cols-2 gap-8">
            <ScoreCircle score="100" label="Performance" delay={0.2} />
            <ScoreCircle score="100" label="Accessibilité" delay={0.3} />
            <ScoreCircle score="100" label="Best Practices" delay={0.4} />
            <ScoreCircle score="100" label="SEO" delay={0.5} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Performance;
